/* This is generated code, don't alter */
var IfcBuildingSystemTypeEnum;
(function (IfcBuildingSystemTypeEnum) {
    IfcBuildingSystemTypeEnum[IfcBuildingSystemTypeEnum["FENESTRATION"] = 0] = "FENESTRATION";
    IfcBuildingSystemTypeEnum[IfcBuildingSystemTypeEnum["FOUNDATION"] = 1] = "FOUNDATION";
    IfcBuildingSystemTypeEnum[IfcBuildingSystemTypeEnum["LOADBEARING"] = 2] = "LOADBEARING";
    IfcBuildingSystemTypeEnum[IfcBuildingSystemTypeEnum["OUTERSHELL"] = 3] = "OUTERSHELL";
    IfcBuildingSystemTypeEnum[IfcBuildingSystemTypeEnum["SHADING"] = 4] = "SHADING";
    IfcBuildingSystemTypeEnum[IfcBuildingSystemTypeEnum["TRANSPORT"] = 5] = "TRANSPORT";
    IfcBuildingSystemTypeEnum[IfcBuildingSystemTypeEnum["USERDEFINED"] = 6] = "USERDEFINED";
    IfcBuildingSystemTypeEnum[IfcBuildingSystemTypeEnum["NOTDEFINED"] = 7] = "NOTDEFINED";
})(IfcBuildingSystemTypeEnum || (IfcBuildingSystemTypeEnum = {}));
const IfcBuildingSystemTypeEnumCount = 8;
export { IfcBuildingSystemTypeEnum, IfcBuildingSystemTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcBuildingSystemTypeEnum = new Int32Array([1, 24, -4]);
let prefixSumAddressIfcBuildingSystemTypeEnum = new Uint32Array([0, 9, 21, 33, 47, 59, 70, 83, 96]);
let slotMapIfcBuildingSystemTypeEnum = new Int32Array([4, 1, 3, 0, 7, 5, 6, 2]);
let encodedDataIfcBuildingSystemTypeEnum = (new TextEncoder()).encode(".SHADING..FOUNDATION..OUTERSHELL..FENESTRATION..NOTDEFINED..TRANSPORT..USERDEFINED..LOADBEARING.");
let IfcBuildingSystemTypeEnumSearch = new MinimalPerfectHash(gMapIfcBuildingSystemTypeEnum, prefixSumAddressIfcBuildingSystemTypeEnum, slotMapIfcBuildingSystemTypeEnum, encodedDataIfcBuildingSystemTypeEnum);
export { IfcBuildingSystemTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcBuildingSystemTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcBuildingSystemTypeEnumSearch, input, cursor, endCursor);
}
